import { ZaverIconInputs } from 'web-component-library/projects/component-library/src/public-api';
import { Currency, CurrencyCode } from '../currency';
export interface PaymentRequestDto {
  id: string;
  status: string;
  value: Currency;
  amount: number;
  currency: CurrencyCode;
  market: Market;
  language: string;
  lowestPossibleMonthlyPayment: number;
  amountDenotesCreditLimit: boolean;
  title: string;
  description: string;
  merchantDetails: {
    companyName: string;
    logoUrl: string;
  };
  availableMethods: AuthorizedPaymentMethod[];
  settlementMethod: PaymentMethod;
  phoneNumber: string;
  paymentChannel: PaymentChannel;
  lineItems: LineItem[];
  cancelUrl: string;
  successUrl?: string;
  successUrlDelayInMs?: number;
  specificPaymentMethodType?: PaymentMethod;
  specificPaymentMethod?: string;
  requireFurtherAIS: boolean;
  checkoutUiCustomizations?: CheckoutUiCustomizations | null;
  darkModeSetting?: DarkModeSettingType;
}
export interface CheckoutUiCustomizations {
  paymentMethods?: PaymentMethodCustomization[];
}
export interface PaymentMethodCustomization {
  type: PaymentMethod;
  subTitle?: string;
  bulletPoints?: string[];
}

export interface PaymentMethodViewContext {
  identifier: PaymentMethod;
  title: string;
  subTitle: string;
  imgSrc?: string;
  zaverIcon?: ZaverIconInputs;
  bulletPoints: string[];
}

export const DarkModeSetting = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  SYSTEM: 'SYSTEM',
} as const;

export type DarkModeSettingType = typeof DarkModeSetting[keyof typeof DarkModeSetting];

export interface LineItem {
  name: string;
  quantity: number;
  value: Currency;
}

export const PaymentRequestStatus = {
  SETTLED: 'SETTLED',
  OPEN: 'OPEN',
  PROCESSING_SIGNATURE: 'PROCESSING_SIGNATURE',
  PROPRIETARY: 'PROPRIETARY',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
};

export interface AuthorizedPaymentMethod {
  id: string;
  type: PaymentMethod;
  requiredLeqType: LeqType;
  promotionalInterestRate: number;
  promotionalNumberOfInstallments: number;
  promotionalStartFee: number;
  promotionalRecurringFee: number;
  promotionalDurationDays: number;
  promotionalDurationMonths: number;
  description: string;
  lowestPossibleMonthlyPayment: number;
  creditorIdentifier?: CreditorIdentifier;
}

export interface Attachments {
  id: string;
  displayMode: string;
  displayName: string;
  authenticationTypes: AttachmentAuthenticationTypes[];
}

export interface AttachmentData {
  id: String;
  displayName: string;
  displayMode: string;
  url: string;
  authentications: AttachmentAuthenticationTypes[];
}

export interface AttachmentAuthentication {
  id: String;
  authenticationType: AttachmentAuthenticationTypes[];
  nin: string;
  email: string;
  phone: string;
  type: string;
}

export enum AttachmentAuthenticationTypes {
  NONE = 'NONE',
  SE_BANKID = 'SE_BANKID',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  PHONE_NUMBER_VERIFICATION = 'PHONE_NUMBER_VERIFICATION',
}

export interface PaymentMethodVM {
  id: string;
  type: PaymentMethod;
  title: string;
  subTitle: string;
  imgSrc?: string;
  zaverIcon?: ZaverIconInputs;
  bulletPoints: string[];
  promotionalDurationDays?: number;
}

export enum PaymentMethod {
  TRUSTLY = 'TRUSTLY',
  INVOICE = 'INVOICE',
  INVOICE_MCO = 'INVOICE_MCO',
  FINAPI_A2A = 'FINAPI_A2A',

  // CREDIT and CREDIT_DIRECT_DEBIT should show the same terms
  CREDIT = 'CREDIT',
  CREDIT_MCO = 'CREDIT_MCO',
  CREDIT_DIRECT_DEBIT = 'CREDIT_DIRECT_DEBIT',
  CREDIT_STATIC_AMOUNT = 'CREDIT_STATIC_AMOUNT',

  SWISH_EXTERNAL = 'SWISH_EXTERNAL',
  VIPPS_EXTERNAL = 'VIPPS_EXTERNAL',
  INSTANT_DEBIT = 'INSTANT_DEBIT',

  // TOKENIZED_CREDIT_LIMIT and COLLECTIVE_INVOICE should show the same terms
  TOKENIZED_CREDIT_LIMIT = 'TOKENIZED_CREDIT_LIMIT',
  COLLECTIVE_INVOICE = 'COLLECTIVE_INVOICE',

  //TODO MOVE
  PAY_IN_ADVANCE = 'PAY_IN_ADVANCE',

  INSTANT_DEBIT_INVOICE = 'INSTANT_DEBIT_INVOICE',
}

export enum LeqType {
  NONE = 'NONE',
  STANDARD = 'STANDARD',
  SIMPLE = 'SIMPLE',
}

export enum PaymentChannel {
  EMBEDDED_CHECKOUT = 'EMBEDDED_CHECKOUT',
  WEB_CHECKOUT = 'WEB_CHECKOUT',
}

export enum Market {
  AT = 'AT',
  DE = 'DE',
  DK = 'DK',
  NO = 'NO',
  SE = 'SE',
  FI = 'FI',
}

export enum CreditorIdentifier {
  SE_NORDISKA = 'SE_NORDISKA',
  DE_NORDISKA = 'DE_NORDISKA',
  DE_FRINK = 'DE_FRINK',
  SE_FRINK = 'SE_FRINK',
  NO_FRINK = 'NO_FRINK',
  FI_FRINK = 'FI_FRINK',
}
